<script>
    import {emitter} from '../stores.js';
    import { onMount } from "svelte";

    import Iqtcallout from "./iqtcallout.svelte";
    export let title = "Ready to get started?";
    export let copy = "We’re always here for you. Contact us at any time to begin the process.";

    let schedule_element;

    onMount(async () => {
        setTimeout(() => {
            $emitter.on('scheduleClick', ()=>{
                schedule_element.classList.add("expanded"); 
                setTimeout(() => {
                    scrollToTop();                
                }, 250);
                
            });
        });
    });
    // const scrollBy = (amount) => {
    // // const c = document.documentElement.scrollTop || document.body.scrollTop;
    //     if (amount > 0) {
    //         window.requestAnimationFrame(scrollBy);
    //         window.scrollBy(0, amount - amount / 8);
    //     }
    // };
    // scrollToTop();
    const scrollToTop = () => {
        console.log(schedule_element.getBoundingClientRect());
        const c = schedule_element.getBoundingClientRect().y ;
        if (c > 100) {
            window.requestAnimationFrame(scrollToTop);
            window.scrollBy(0, c - c / 8);
        }
    };    

</script>

<div class="ctacontainer">
    <div class="ctaheader">{title}</div>
    <div class="ctatext">{copy}</div>
</div>
<div class="calloutcontainer">
    <slot>

    <Iqtcallout
        logo="/img/Card_phone.svg"
        title="Talk to an Expert"
        text="Speak with a loan consultant now. "
        button_text="Call now"
        button_color_reversed={false}
        button_link="tel:866-528-3814"
    />
    <Iqtcallout
        logo="/img/Calendar_check.svg"
        title="Schedule a Call"
        text="Make an appointment time that fits your schedule."
        button_text="Book appointment"
        button_color_reversed={false}
        button_function={()=>{
            schedule_element.classList.add("expanded"); 
            setTimeout(() => {
                scrollToTop();
                // window.scrollBy({top: 800, left: 0, behavior: 'smooth'});
                // var rect = schedule_element.getBoundingClientRect();
                // window.scrollTo(rect.x, rect.y)
                // window.scrollTo({behavior: "smooth", top: rect.y, left: rect.x});
                
            }, 250);
            }}
    />
    <!-- button_link="https://outlook.office365.com/owa/calendar/SemperHomeLoans4@semperhl.com/bookings/" -->
    <Iqtcallout
        logo="/img/House_2.svg"
        title="Apply in Minutes"
        text="Fill out a quick application in our HomeEasy app."
        button_text="Get Started"
        button_color_reversed={false}
        button_link="https://homeeasy.semperhl.com/homehub/signup/ASKSEMPER@SEMPERHL.COM"
    />
</slot>
</div>

<div bind:this={schedule_element} class="scheduleholder">
    <iframe title="" src="https://outlook.office365.com/owa/calendar/SemperHomeLoans4@semperhl.com/bookings/" frameborder="0"></iframe>
</div>

<style>
.ctacontainer {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
}
.ctaheader {
    text-align: center;
    font-weight: 600;
    color: black;
    font-size: 3em;
}
.ctatext {
    width: 60%;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-weight: normal;
    font-size: 1em;
    line-height: 1.5em;
    color: var(--blueslate);
    margin-top: 15px;
}
.calloutcontainer {
    margin-top: 50px;
    margin-bottom: 50px;
    width: 60%;
    min-width: 800px;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-between;
}
.scheduleholder {
    position: absolute;
    left: 0;
    width: 100vw !important;
    transition: height .5s ease-in-out;
    height: 0;
    /* padding-bottom: 56.25%;     */
}
:global(.scheduleholder.expanded) {
    height: 1400px !important;
}
.scheduleholder iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

}
@media (max-device-width: 1200px), (max-width: 1199px) {

    .ctacontainer {
        width: 100%;
    }
    .ctaheader {
        font-size: 2em;
    }
    .ctatext {
        width: 80%;
        line-height: 1.5em;
    }

    .calloutcontainer {
        flex-direction: column;
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        align-items: center;
        box-sizing: border-box;
    }
}
</style>